// ============================================================================
// The consent screen's two lists (item #853), as the approved demo's tab 3 words
// them. Pure, so build-room-connector/connector.test.ts can check every tool the
// connector offers is named here, and nothing else is.
// ============================================================================

/** What Claude can read (the connector's read tools). */
export const CAN_SEE = [
  "The open items on the board, in the command center's order",
  'What the bots are running now',
  'The demos on the demo shelf',
];
/** What Claude can press (the connector's write tools, picks 1A 2B 3A applied). */
export const CAN_DO = [
  'Approve, push back, park, unpark, set priority, pin',
  'File a new build item',
  'Add a note or your decision to an item',
  'Ask the merge gate to merge',
  'Close a ready-to-close item, or keep it open',
];
